module.exports = "/packs/images/accessibility~a2749e992f644f41b78822a232ba61c7.svg";